var map = {
	"./O__logo_DK.png": 922,
	"./O__logo_WT.png": 4800,
	"./Unity Certified VR Developer.png": 1588,
	"./Unity certified Programmer.png": 4374,
	"./VR_Specialist_Badge.png": 6452,
	"./address_image.svg": 3906,
	"./android-icon-144x144.png": 9576,
	"./android-icon-192x192.png": 72,
	"./android-icon-36x36.png": 3074,
	"./android-icon-48x48.png": 6912,
	"./android-icon-72x72.png": 1714,
	"./android-icon-96x96.png": 5478,
	"./android.svg": 6705,
	"./animated_ashutosh.png": 8009,
	"./animated_logo.svg": 9083,
	"./apple-icon-114x114.png": 6739,
	"./apple-icon-120x120.png": 8459,
	"./apple-icon-144x144.png": 9119,
	"./apple-icon-152x152.png": 5951,
	"./apple-icon-180x180.png": 4159,
	"./apple-icon-57x57.png": 6095,
	"./apple-icon-60x60.png": 723,
	"./apple-icon-72x72.png": 3509,
	"./apple-icon-76x76.png": 7117,
	"./apple-icon-precomposed.png": 6836,
	"./apple-icon.png": 3088,
	"./apple-touch-icon.png": 4322,
	"./aust.png": 3477,
	"./aust_logo.png": 1907,
	"./blogs_image.svg": 7245,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./codeexcel.jpg": 9900,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./favicon-16x16.png": 6461,
	"./favicon-32x32.png": 9197,
	"./favicon-96x96.png": 4013,
	"./favicon.ico": 9538,
	"./favicon1.ico": 6840,
	"./feelingProud.svg": 8294,
	"./freecopy_logo.png": 4633,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./ibm_logo.png": 262,
	"./iiitk_logo.png": 6200,
	"./intel_logo.jpg": 8504,
	"./jsFramework.svg": 9655,
	"./legato_logo.png": 1236,
	"./logo192.png": 6015,
	"./logo512.png": 8971,
	"./manOnTable.svg": 7473,
	"./michigan_logo.png": 3356,
	"./microsoft_logo.png": 752,
	"./moon.svg": 9663,
	"./mozilla_logo.png": 6816,
	"./ms-icon-144x144.png": 8729,
	"./ms-icon-150x150.png": 4101,
	"./ms-icon-310x310.png": 6249,
	"./ms-icon-70x70.png": 2067,
	"./muffito_logo.png": 9556,
	"./new images/favicon.zip": 318,
	"./new images/favicon/apple-touch-icon.png": 624,
	"./new images/favicon/favicon-96x96.png": 527,
	"./new images/favicon/favicon.ico": 537,
	"./new images/favicon/favicon.svg": 4352,
	"./new images/favicon/site.webmanifest": 7366,
	"./new images/favicon/web-app-manifest-192x192.png": 9009,
	"./new images/favicon/web-app-manifest-512x512.png": 881,
	"./new images/favicon_io.zip": 6183,
	"./new images/favicon_io/android-chrome-192x192.png": 9054,
	"./new images/favicon_io/android-chrome-512x512.png": 4750,
	"./new images/favicon_io/apple-touch-icon.png": 7553,
	"./new images/favicon_io/favicon-16x16.png": 6656,
	"./new images/favicon_io/favicon-32x32.png": 3852,
	"./new images/favicon_io/favicon.ico": 6460,
	"./new images/favicon_io/site.webmanifest": 9713,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./pixelmask_logo.png": 5108,
	"./pluralsight_logo.png": 7791,
	"./portfolio.gif": 8467,
	"./profile circle 400x400.png": 8831,
	"./profile.png": 923,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pwa.png": 9180,
	"./saayaHealthLogo.png": 4176,
	"./skill.svg": 8707,
	"./stanford_logo.png": 6691,
	"./sun.svg": 8950,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./tasin.png": 9325,
	"./tencon.png": 1837,
	"./ui_ux_design.svg": 9163,
	"./web-app-manifest-192x192.png": 2379,
	"./web-app-manifest-512x512.png": 5875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;